// extracted by mini-css-extract-plugin
export default {"labelDotsContainer":"LabelDots-module__labelDotsContainer--zVdn0","labelDot":"LabelDots-module__labelDot--HphCf"};